import { useState } from "react";
import "@/App.css";
import { Toaster } from "./components/ui/sonner";
import AuthScreen from "./components/AuthScreen";
import Dashboard from "./components/Dashboard";
import { api, tokens } from "./lib/api";

function App() {
  const [mode, setMode] = useState(tokens.get() ? "dash" : "auth");
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    tokens.clear();
    setMode("auth");
  };
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      {mode === "auth" ? (
        <AuthScreen onAuthed={() => setMode("dash")} onViewOnly={() => setMode("view")} />
      ) : (
        <Dashboard onLogout={logout} onLogin={() => { tokens.clear(); setMode("auth"); }} />
      )}
    </div>
  );
}

export default App;
